import styled from "styled-components";
// import palette from "../../../lib/styles/palette";
import { useState } from "react";
import Button from "../../common/Button";
import AskProfileSelectModal from "./AskProfileSelectModal";

const ProfileSelectButtonBlock = styled.div`


`; 


const ProfileSelectButton = ({ setProfile, setProfileImageNumber }) => {
    const [modal, setModal] = useState(false);

    const onSelectProfile = () => {
        setModal(true);
    }


    const [imgNumber, setImgNumber] = useState('');
    const onConfirm = () => {
        // setProfileImageNumber(imgNumber);
        setProfile(prev => ({
            ...prev,
            imgNumber,
        }));
        setModal(false);
    }

    const onCancel = () => {
        setModal(false);
    }

    return (
        <ProfileSelectButtonBlock>
            <Button cyan onClick={onSelectProfile} >Select Profile</Button>
            <AskProfileSelectModal visible={modal} onConfirm={onConfirm} onCancel={onCancel} setImgNumber={setImgNumber} />
        </ProfileSelectButtonBlock>
    );
};

export default ProfileSelectButton;

